import React from "react"
import { BarChart3 } from "lucide-react"

export default function EmptyReportState({ message = "No data in this date range.", cta }) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-slate-300 py-16 text-center">
      <BarChart3 className="mb-3 h-10 w-10 text-slate-300" />
      <p className="text-[14px] text-slate-500">{message}</p>
      {cta && <div className="mt-3">{cta}</div>}
    </div>
  )
}
